import ah_kakaya_pora from './ah_kakaya_pora';
import belyj_zakat from './belyj_zakat';
import vot_pobeda from './vot_pobeda';
import sonet from './sonet';
import v_pamjat_o from './v_pamjat_o';
import v_predchuvstvii_zimy from './v_predchuvstvii_zimy';
import vnuku from './vnuku';
import vse_nadezjdy_razbivajutsa from './vse_nadezjdy_razbivajutsa';
import estestvennaja_evolucija from './estestvennaja_evolucija';
import kak_list_uvjadshiy from './kak_list_uvjadshiy';
import kak_obstupaet_nas_krugovorot from './kak_obstupaet_nas_krugovorot';
import ne_priznaju_v_bereze_krasoty from './ne_priznaju_v_bereze_krasoty';
import pesni_malenkogo_cheloveka from './pesni_malenkogo_cheloveka';
import pesn_neevropejca from './pesn_neevropejca';
import pesn_torjestvujuschego_bezjenca from './pesn_torjestvujuschego_bezjenca';
import revolucioner from './revolucioner';
import sonet_o_zjestokoy from './sonet_o_zjestokoy';
import holodno from './holodno';
import ya_lublu_esperanto from './ya_lublu_esperanto';
import limeriki from './limeriki';
import konĉaetsa_veter from './konĉaetsa_veter';
import burime from './burime';
import diptih from './diptih';
import nochi_polnye_straha from './nochi_polnye_straha';
import noyabr from './noyabr';
import moy_mir_razrushen from './moy_mir_razrushen';

const list = [
  ah_kakaya_pora,
  belyj_zakat,
  vot_pobeda,
  sonet,
  sonet_o_zjestokoy,
  v_pamjat_o,
  v_predchuvstvii_zimy,
  vnuku,
  vse_nadezjdy_razbivajutsa,
  estestvennaja_evolucija,
  kak_list_uvjadshiy,
  kak_obstupaet_nas_krugovorot,
  ne_priznaju_v_bereze_krasoty,
  pesni_malenkogo_cheloveka,
  pesn_neevropejca,
  pesn_torjestvujuschego_bezjenca,
  revolucioner,
  holodno,
  ya_lublu_esperanto,
  limeriki,
  konĉaetsa_veter,
  burime,
  diptih,
  nochi_polnye_straha,
  noyabr,
  moy_mir_razrushen
];

export default list;